var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataFetched())?_c('div',{staticClass:"landing"},[_c('home'),_c('about'),_c('service'),_c('product-type'),_c('product'),_c('order-product'),_c('process'),_c('partner'),_c('get-project'),_c('technologies'),_c('client'),_c('custom-footer'),_c('copy')],1):_c('loader3')
}
var staticRenderFns = []

export { render, staticRenderFns }